// global-combined 241030d
// Dawn global + LS global
class Component extends HTMLElement {
  refs = {};
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }

  connectedCallback() {
    this.#updateRefs();
  }

  #updateRefs() {
    const refs = {};
    const elements = this.roots.reduce((acc, root) => {
      for (const element of root.querySelectorAll("[ref]")) {
        acc.add(element);
      }
      return acc;
    }, new Set());

    for (const ref of elements) {
      const refName = ref.getAttribute("ref") ?? "";
      const isArray = refName.endsWith("[]");
      const path = isArray ? refName.slice(0, -2) : refName;

      if (isArray) {
        const array = Array.isArray(refs[path]) ? refs[path] : [];

        array.push(ref);
        refs[path] = array;
      } else {
        refs[path] = ref;
      }
    }

    if (this.requiredRefs?.length) {
      for (const ref of this.requiredRefs) {
        if (!(ref in refs)) {
          throw new MissingRefError(ref, this);
        }
      }
    }
    this.refs = /** @type {RefsType<T>} */ (refs);
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling) {
    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

document
  .querySelectorAll("details.mega-menu, details.dropdown-menu")
  .forEach((details) => {
    let disclosure = details.closest("header-menu");
    if (!disclosure) return;
    summary = details.querySelector("summary");
    details.addEventListener("mouseover", () => {
      details.setAttribute("open", true);
      summary.setAttribute("aria-expanded", true);
    });
    details.addEventListener("mouseout", () => {
      disclosure.close();
    });
  });

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  //document.querySelectorAll('video').forEach((video) => video.pause());
  document
    .querySelectorAll("video:not(.r-js-video-do-not-pause)")
    .forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    //this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll("button:not(.r-menu-drawer-prevent-close)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class ModalOpenerPswp extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", () => {
      if (!PhotoSwipeLightbox || !PhotoSwipe) return;
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.open(button);
    });
  }
}

customElements.define("modal-opener-pswp", ModalOpenerPswp);

class ModalPswp extends HTMLElement {
  constructor() {
    super();
    this.lightbox = null;
    this.container = this.querySelector(".pswp-gallery");
    this.elements = Array.from(this.querySelectorAll(".pswp-gallery a"));

    document.addEventListener("DOMContentLoaded", (event) => {
      this.initLightbox();
    });
  }

  initLightbox(newEl = false) {
    if (newEl)
      this.elements = Array.from(this.querySelectorAll(".pswp-gallery a"));
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.container,
      children: "a",
      pswpModule: () => PhotoSwipe,
      returnFocus: false,
      zoom: false,
      bgOpacity: 1,
      counter: false,
      showHideAnimationType: "fade",
    });

    this.lightbox.on("uiRegister", () => {
      this.lightbox.pswp.ui.registerElement({
        name: "bulletsIndicator",
        className: "pswp__bullets-indicator",
        appendTo: "wrapper",
        onInit: (el, pswp) => {
          const bullets = [];
          let bullet;
          let prevIndex = -1;
          let prev = (bullet = document.createElement("button"));
          prev.className = "pswp__bullet-prev";
          prev.innerHTML =
            '<svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"> <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';
          prev.onclick = (e) => {
            this.lightbox.pswp.prev();
          };
          let next = (bullet = document.createElement("button"));
          next.className = "pswp__bullet-next";
          next.innerHTML =
            '<svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';
          next.onclick = (e) => {
            this.lightbox.pswp.next();
          };
          el.appendChild(prev);
          let bulletcontainer = document.createElement("div");
          bulletcontainer.className = "pswp__bullet-container";

          for (let i = 0; i < pswp.getNumItems(); i++) {
            bullet = document.createElement("div");
            bullet.className = "pswp__bullet";
            bullet.onclick = (e) => {
              this.lightbox.pswp.goTo(bullets.indexOf(e.target));
            };
            bulletcontainer.appendChild(bullet);
            bullets.push(bullet);
          }
          el.appendChild(bulletcontainer);
          el.appendChild(next);

          this.lightbox.pswp.on("change", (a) => {
            if (prevIndex >= 0) {
              bullets[prevIndex].classList.remove("pswp__bullet--active");
            }
            bullets[this.lightbox.pswp.currIndex].classList.add(
              "pswp__bullet--active",
            );
            prevIndex = this.lightbox.pswp.currIndex;
          });
        },
      });
    });
    this.lightbox.init();
  }

  open(btn) {
    if (!PhotoSwipeLightbox || !PhotoSwipe || !this.lightbox) return;
    const { mediaId } = btn.dataset;
    const element = this.container.querySelector(`a[data-media="${mediaId}"]`);
    let index = this.elements.indexOf(element);
    this.lightbox.loadAndOpen(index, {
      gallery: this.container,
    });
    window.pauseAllMedia();
  }
}

customElements.define("modal-pswp", ModalPswp);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  connectedCallback() {
    const template = this.querySelector("template");
    if (!template) return;

    const isVideo = template.content.querySelector("video");
    if (!isVideo) return;

    // Auto-load video when it enters the viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        this.loadContent(false);
        observer.disconnect();
      });
    }, { threshold: 0.1 });

    observer.observe(this);
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    // for homepage categories
    if (this.classList.value == "r-home-categories-slider") {
      this.totalPages = Number(
        this.querySelector(".slider-counter--total").innerText,
      );
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    let step = event.currentTarget.dataset.step || 1;

    // Step (improved) to next page
    let liElement = this.slider.querySelector("li");
    if (liElement !== null) {
      let itemsPerPage = Math.round(
        this.slider.clientWidth / liElement.clientWidth,
      );
      step = itemsPerPage;
    }

    //this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);

    if (event.currentTarget.name === "next") {
      this.slideScrollPosition =
        this.slider.scrollLeft + step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition =
        this.slider.scrollLeft - step * this.sliderItemOffset;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  checkCombinedListing() {
    const combinedListing = this.getAttribute("data-combined-listing");
    if (combinedListing) {
      this.combinedListing = true;
    }
  }

  onVariantChange() {
    this.checkCombinedListing();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true,
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    if (this.combinedListing) {
      return null;
    }

    this.variantData =
      this.variantData ||
      JSON.parse(
        this.querySelector('#variants_data[type="application/json"]')
          ?.textContent,
      );
    console.log(this.variantData);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

/*
  LS - Slider
*/

class LasiestaSliderComponent extends HTMLElement {
  constructor() {
    super();

    this.sliderUl = this.querySelector('[id^="Slider-"]');
    this.sliderItemsArray = Array.from(this.querySelectorAll('[id^="Slide-"]'));

    this.enableSliderLooping = false;

    this.counterCurrentElement = this.querySelector(".slider-counter--current");
    this.counterTotalElement = this.querySelector(".slider-counter--total");
    this.querySelector(".slider-buttons").style.display = "none";

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    // Debug
    this.sliderDebugId = this.sliderUl.getAttribute("id").slice(-3);
    this.isDebug = false;

    if (!this.sliderUl || !this.nextButton) return;

    this.scrollSnapIndexCurrent = 0;
    this.scrollSnapIndexLast = 0;

    this.initPages("init");

    const resizeObserver = new ResizeObserver((entries) =>
      this.resizeHandler(),
    );
    resizeObserver.observe(this.sliderUl);

    this.sliderUl.addEventListener("scroll", this.scrollHandler.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  resizeHandler() {
    this.initPages("resize");
  }

  scrollHandler() {
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages("reset");
  }

  initPages(debug = "") {
    this.debug({
      method: "initPages/1",
      tricker: debug,
    });

    if (this.sliderItemsArray.length < 2) return;

    // Item width
    this.itemWidth =
      this.sliderItemsArray[1].offsetLeft - this.sliderItemsArray[0].offsetLeft;

    if (this.itemWidth == 0) return;

    // Scroll snapIndexLast
    let visibleItems = Math.round(this.sliderUl.clientWidth / this.itemWidth); // 1.99 = 2
    let scrollSnapIndexLast = this.sliderItemsArray.length - visibleItems;
    if (scrollSnapIndexLast < 0) {
      scrollSnapIndexLast = 0;
    }
    this.scrollSnapIndexLast = scrollSnapIndexLast;

    // View
    this.querySelector(".slider-buttons").style.display =
      this.scrollSnapIndexLast == 0 ? "none" : "flex";

    this.debug({
      method: "initPages/2",
      slider_width: this.sliderUl.clientWidth,
      item_width: this.itemWidth,
      items: this.sliderItemsArray.length,
      scrollSnapIndexLast: this.scrollSnapIndexLast,
    });

    this.update();
  }

  update() {
    if (this.itemWidth == 0) return;

    let scrollSnapIndexCurrent = Math.round(
      this.sliderUl.scrollLeft / this.itemWidth,
    ); // Scroll snap index, changes by drag as well, 0.2 -> 0, 0.8 -> 1, 1.2 -> 1
    this.scrollSnapIndexCurrent = scrollSnapIndexCurrent;

    this.debug({
      method: "update",
      scrollPosition: this.sliderUl.scrollLeft,
      scrollSnapIndexCurrent: this.scrollSnapIndexCurrent,
    });

    // View
    this.counterCurrentElement.textContent = this.scrollSnapIndexCurrent + 1;
    this.counterTotalElement.textContent = this.scrollSnapIndexLast + 1;

    if (this.scrollSnapIndexCurrent == 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.scrollSnapIndexCurrent == this.scrollSnapIndexLast) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    // Step (improved) to next page
    let step = 1;
    let liElement = this.sliderUl.querySelector("li");
    if (liElement !== null) {
      let itemsPerPage = Math.round(
        this.sliderUl.clientWidth / liElement.clientWidth,
      );
      step = itemsPerPage;
    }

    if (event.currentTarget.name === "next") {
      let scrollSnapIndexNew = this.scrollSnapIndexCurrent + step;
      if (scrollSnapIndexNew > this.scrollSnapIndexLast) {
        scrollSnapIndexNew = this.scrollSnapIndexLast;
      }
      this.slideScrollPosition = scrollSnapIndexNew * this.itemWidth;
    }

    if (event.currentTarget.name === "previous") {
      let scrollSnapIndexNew = this.scrollSnapIndexCurrent - step;
      if (scrollSnapIndexNew < 0) {
        scrollSnapIndexNew = 0;
      }
      this.slideScrollPosition = scrollSnapIndexNew * this.itemWidth;
    }

    this.sliderUl.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  debug(args) {
    if (this.isDebug) {
      console.log({ slider_id: this.sliderDebugId, ...args });
    }
  }
}

customElements.define("slider-component2", LasiestaSliderComponent);

/*
  LS - Scroll to
*/

class LasiestaScrollTo {
  constructor() {
    this.isDebug = false;
  }

  init(args) {
    let root = this;

    args.scroll_link_element.style.cursor = "pointer";

    args.scroll_link_element.onclick = function (event) {
      event.preventDefault();

      // ScrollTo
      root.scrollTo(args);

      // ScrollTo, second time after some ms, sometimes problems maybe because of lazy images
      if (args.hasOwnProperty("scroll_to_again_after_ms")) {
        setTimeout(function () {
          root.scrollTo(args);
        }, args.scroll_to_again_after_ms);
      }
    };
  }

  scrollTo(args) {
    let root = this;
    let newScrollPos = root.calculateScrollPos(args);
    window.scrollTo({
      top: newScrollPos,
      behavior: "smooth",
    });
  }

  calculateScrollPos(args) {
    let targetScrollPos = args.scroll_target_element.offsetTop;
    let currentScrollPos = window.scrollY;
    let fixedHeaderSpace = 0;

    // Scroll down - header hidden
    if (targetScrollPos > currentScrollPos) {
      fixedHeaderSpace = 0;
    }

    // Scroll up - header visible
    if (targetScrollPos < currentScrollPos) {
      let headerElement = document.querySelector(".section-header");
      if (headerElement !== null) {
        fixedHeaderSpace = headerElement.clientHeight;
      }
    }

    let newScrollPos = targetScrollPos - fixedHeaderSpace;

    if (args.hasOwnProperty("extra")) {
      newScrollPos = newScrollPos + args.extra;
    }

    return newScrollPos;
  }

  debug(args) {
    if (this.isDebug) {
      console.log(args);
    }
  }
}

class LasiestaTabHeader extends HTMLElement {
  constructor() {
    super();

    let scrollTo = new LasiestaScrollTo();

    this.querySelectorAll("li[scroll_link]").forEach(
      function (scrollLinkElement) {
        let identifier = scrollLinkElement.getAttribute("scroll_link");
        let scrollTargetElement = document.querySelector(
          'r-tab-header[scroll_target="' + identifier + '"]',
        );
        if (scrollTargetElement !== null) {
          scrollTargetElement.style.display = "block"; // firefox scrollY fix
          scrollTo.init({
            scroll_link_element: scrollLinkElement,
            scroll_target_element: scrollTargetElement,
          });
        }
      },
    );
  }
}

customElements.define("r-tab-header", LasiestaTabHeader);

/*
  LS - Scroll to - button
*/
class ScrollToButton extends HTMLElement {
  constructor() {
    super();
    let scrollLinkElement = this;
    let scrollTargetElement = null;
    let scrollTargetClass = this.getAttribute("scroll_to");
    if (scrollTargetClass != null) {
      scrollTargetElement = document.querySelector("." + scrollTargetClass);
    }
    if (scrollTargetElement !== null) {
      let scrollTo = new LasiestaScrollTo();
      scrollTo.init({
        scroll_link_element: scrollLinkElement,
        scroll_target_element: scrollTargetElement,
        scroll_to_again_after_ms: 700,
        //extra: -30,
      });
    } else {
      scrollLinkElement.classList.add("r-disabled");
    }
  }
}

customElements.define("r-scroll-to-button", ScrollToButton);

/*
  LS - Scroll to link
*/
class ScrollTo extends HTMLElement {
  constructor() {
    super();

    let scrollLinkElement = null;
    let scrollTargetElement = null;

    // a #
    let aElement = this.querySelector("a");
    if (aElement !== null) {
      let aHref = aElement.getAttribute("href");
      if (aHref.match(/#(.*)$/)) {
        scrollLinkElement = aElement;
        scrollTargetElement = document.querySelector(aHref);
        // if parent target section is seperator, scroll to parent section
      }
    }

    if (scrollTargetElement !== null) {
      scrollTargetElement.style.borderTop = "solid 1px rgb(0 0 0 / 0%)"; // temp fix scroll to div top, otherwise scrolls to a top somehow
      let scrollTo = new LasiestaScrollTo();
      scrollTo.init({
        scroll_link_element: scrollLinkElement,
        scroll_target_element: scrollTargetElement,
        scroll_to_again_after_ms: 700,
      });
    } else {
      scrollLinkElement.classList.add("r-scroll-target-404");
    }
  }
}

customElements.define("r-scroll-to", ScrollTo);

/*
  LS - ScrollUp
*/
class ScrollUp extends HTMLElement {
  constructor() {
    super();

    let scrollLinkElement = null;
    let scrollTargetElement = this;

    let bodyElement = document.querySelector("body");
    let buttonElement = document.createElement("div");
    buttonElement.innerHTML = this.hasAttribute("button_label")
      ? this.getAttribute("button_label")
      : "Up";
    buttonElement.classList.add("r-scroll-up-button");
    buttonElement.classList.add("r-hide");
    bodyElement.append(buttonElement);
    scrollLinkElement = buttonElement;

    let scrollTo = new LasiestaScrollTo();
    scrollTo.init({
      scroll_link_element: scrollLinkElement,
      scroll_target_element: scrollTargetElement,
      scroll_to_again_after_ms: 700,
    });

    this.scrollLinkElement = scrollLinkElement;
    this.scrollTargetElement = scrollTargetElement;
    this.stateScrollTopShowTresholdReached = false;
    window.addEventListener(
      "scroll",
      function () {
        this.scrollHandler();
      }.bind(this),
    );
  }

  scrollHandler() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // is value1 if valid, otherwise value2
    let scrollTopShowTreshold = this.scrollTargetElement.offsetTop + 1000;
    let scrollTopShowTresholdReached = scrollTop > scrollTopShowTreshold;

    if (
      scrollTopShowTresholdReached != this.stateScrollTopShowTresholdReached
    ) {
      this.stateScrollTopShowTresholdReached = scrollTopShowTresholdReached;

      // Change handler
      if (this.stateScrollTopShowTresholdReached) {
        this.scrollLinkElement.classList.remove("r-hide");
      } else {
        this.scrollLinkElement.classList.add("r-hide");
      }
    }
  }
}

customElements.define("r-scroll-up-target", ScrollUp);

/*
  LS - Modal
*/
class ModalButton extends HTMLElement {
  constructor() {
    super();
    this.debug = true;

    // (outdated)
    if (
      this.getAttribute("modal-identifier") !== null &&
      this.getAttribute("modal-content-source") != null
    ) {
      this.modalInit(
        this.getAttribute("modal-identifier"),
        this.getAttribute("modal-content-source"),
      );
    }

    // (dataset)
    if (
      this.dataset.hasOwnProperty("modalIdentifier") &&
      this.dataset.hasOwnProperty("modalContentType")
    ) {
      this.modalInit(
        this.dataset.modalIdentifier,
        this.dataset.modalContentType,
      );
    }
  }

  modalInit(identifier, contentSourceType) {
    let buttonIdentifierClass = identifier + "-button";

    if (contentSourceType == "alias") {
      let buttonElement = this.querySelector(".r-modal-button");
      if (buttonElement !== null) {
        buttonElement.classList.add(buttonIdentifierClass);
      }
    }

    if (contentSourceType == "html") {
      let buttonElement = this.querySelector(".r-modal-button");
      let contentElement = this.querySelector(".r-modal-content");
      if (buttonElement !== null && contentElement !== null) {
        buttonElement.classList.add(buttonIdentifierClass);
        this.modalCreate({
          id: identifier,
          opener_button_selector: "." + buttonIdentifierClass,
          header_space: false,
          content: contentElement.innerHTML,
        });
        contentElement.remove();
        return;
      }
    }

    if (contentSourceType == "youtube-url") {
      let buttonElement = this.querySelector("a.r-modal-button");
      let contentUrl = null;
      if (buttonElement !== null) {
        contentUrl = buttonElement.getAttribute("href");
      }
      if (buttonElement !== null && contentUrl != null) {
        buttonElement.classList.add(buttonIdentifierClass);
        this.modalCreate({
          id: identifier,
          opener_button_selector: "." + buttonIdentifierClass,
          content_youtube_url: contentUrl,
          close_remove_content: true,
          max_width: "1000px",
        });
        return;
      }
    }

    if (contentSourceType == "content-url") {
      let buttonElement = this.querySelector("a.r-modal-button");
      let contentUrl = null;
      if (buttonElement !== null) {
        contentUrl = buttonElement.getAttribute("href");
      }
      if (buttonElement !== null && contentUrl != null) {
        buttonElement.classList.add(buttonIdentifierClass);
        this.modalCreate({
          id: identifier,
          opener_button_selector: "." + buttonIdentifierClass,
          content_ajax_url: contentUrl,
          max_width: "900px",
          header_space: false,
        });
        return;
      }
    }
  }

  modalCreate(args = {}) {
    let modal = document.createElement("div");
    modal.classList.add("r-modal");
    if (args.hasOwnProperty("id")) {
      modal.setAttribute("id", args.id);
    }
    if (args.hasOwnProperty("class_list")) {
      root.addElementClasses(modal, args.class_list);
    }

    let modalDialog = document.createElement("div");
    modalDialog.classList.add("r-modal-dialog");
    modalDialog.setAttribute("role", "document");
    if (args.hasOwnProperty("max_width")) {
      modalDialog.style.maxWidth = args.max_width;
    }
    modal.append(modalDialog);

    let modalContent = document.createElement("div");
    modalContent.classList.add("r-modal-content");
    modalDialog.append(modalContent);

    let modalHeader = document.createElement("div");
    modalHeader.classList.add("r-modal-header");
    modalContent.append(modalHeader);
    if (args.hasOwnProperty("header_space")) {
      if (args.header_space == false) {
        modalHeader.classList.add("r-modal-header-space-false");
      }
    }

    let closeButton = document.createElement("button");
    closeButton.setAttribute("type", "button");
    closeButton.classList.add("r-button-close");
    modalHeader.append(closeButton);

    let modalBody = document.createElement("div");
    modalBody.classList.add("r-modal-body");
    modalContent.append(modalBody);

    document.querySelector("body").append(modal);

    // Init
    args.modal = modal;
    args.modal_body = modalBody;
    args.modal_close_button = closeButton;

    // Close on backdrop click (target is the overlay itself, not a child)
    let root = this;
    modal.addEventListener("click", function (backdropEvent) {
      if (!backdropEvent.target.closest(".r-modal-dialog")) {
        root.modalEvent("close", args);
      }
    });

    // Close on Escape key (only when this modal is visible)
    document.addEventListener("keyup", function (keyEvent) {
      if (keyEvent.key === "Escape" && modal.classList.contains("r-show")) {
        root.modalEvent("close", args);
      }
    });

    // Wait until dom is loaded, required with multiple opener buttons
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        this.modalEvent("init", args);
      }.bind(this),
    );
  }

  modalEvent(eventName, args) {
    if (this.debug) {
      console.log({ type: "event", eventName: eventName, args: args });
    }

    let root = this;

    if (eventName == "init") {
      // Close Button
      args.modal_close_button.onclick = function (buttonEvent) {
        buttonEvent.preventDefault();
        root.modalEvent("close", args);
      };
      // Opener Buttons
      let openerButtons = document.querySelectorAll(
        args.opener_button_selector,
      );
      openerButtons.forEach(function (button) {
        button.onclick = function (buttonEvent) {
          buttonEvent.preventDefault();
          root.modalEvent("open", args);
        };
      });
      // State
      args.modal.setAttribute("aria-hidden", "true");
    }

    if (eventName == "open") {
      // State
      args.modal.removeAttribute("aria-hidden");
      args.modal.setAttribute("aria-modal", "true");
      args.modal.setAttribute("role", "dialog");
      args.modal.classList.add("r-show");
      document.querySelector("body").classList.add("r-modal-open");

      // Content
      if (args.hasOwnProperty("content")) {
        args.modal_body.innerHTML = args.content;
      }

      // Content - Ajax
      if (args.hasOwnProperty("content_ajax_url")) {
        root.modalEvent("open-content-ajax", args);
      }

      // Content - Youtube
      if (args.hasOwnProperty("content_youtube_url")) {
        root.modalEvent("open-content-youtube", args);
      }
    }

    if (eventName == "close") {
      // State
      args.modal.removeAttribute("aria-modal");
      args.modal.setAttribute("aria-hidden", "true");
      args.modal.classList.remove("r-show");
      args.modal.removeAttribute("role");
      document.querySelector("body").classList.remove("r-modal-open");
      // test
      if (args.hasOwnProperty("close_remove_content")) {
        args.modal_body.innerHTML = "";
      }
    }

    if (eventName == "open-content-ajax") {
      args.modal_body.innerHTML = "loading...";
      let xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          // done
          if (xhr.status == "200") {
            args.modal_body.innerHTML = xhr.responseText;
            root.modalEvent("open-content-ajax-feedback", args);
          } else {
            args.modal_body.innerHTML = "404";
          }
        }
      };
      xhr.open("GET", args.content_ajax_url, true);
      xhr.send("");
    }

    if (eventName == "open-content-ajax-feedback") {
      document
        .querySelectorAll(".r-modal-feedback")
        .forEach(function (feedbackElement) {
          let thankyouElement = feedbackElement.querySelector(".thank-you");
          thankyouElement.style.display = "none";
          feedbackElement
            .querySelectorAll("button")
            .forEach(function (buttonElement) {
              buttonElement.onclick = function (event) {
                thankyouElement.style.display = "block";
              };
            });
        });
    }

    if (eventName == "open-content-youtube") {
      args.modal_body.innerHTML = "";
      let youtubeCode = root.getYoutubeUrlCode(args.content_youtube_url);
      if (youtubeCode != undefined) {
        if (!args.hasOwnProperty("youtube_content")) {
          let content = document.createElement("div");
          let loading = document.createElement("div");
          loading.innerHTML = "loading...";
          root.addElementStyles(loading, { position: "absolute" });
          content.append(loading);
          let ratioContainer = document.createElement("div");
          root.addElementStyles(ratioContainer, {
            position: "relative",
            width: "100%",
            paddingTop: "56.25%",
          });
          content.append(ratioContainer);
          let ratioInnerContainer = document.createElement("div");
          root.addElementStyles(ratioInnerContainer, {
            position: "absolute",
            top: "0",
            left: "0",
            bottom: "0",
            right: "0",
          });
          ratioContainer.append(ratioInnerContainer);
          let iframeSrc =
            "https://www.youtube-nocookie.com/embed/" +
            youtubeCode +
            "?rel=0&amp;showinfo=0;wmode=transparent";
          let iframe = document.createElement("iframe");
          root.addElementAttributes(iframe, {
            width: "100%",
            height: "100%",
            src: iframeSrc,
            frameborder: "0",
            allowfullscreen: "",
          });
          ratioInnerContainer.append(iframe);
          args.youtube_content = content;
        }

        args.modal_body.append(args.youtube_content);
      }
    }
  }

  addElementAttributes(element, attributes) {
    Object.keys(attributes).forEach(function (key) {
      element.setAttribute(key, attributes[key]);
    });
  }

  addElementClasses(element, classes) {
    classes.forEach(function (item) {
      element.classList.add(item);
    });
  }

  addElementStyles(element, styles) {
    Object.keys(styles).forEach(function (key) {
      element.style[key] = styles[key];
    });
  }

  getYoutubeUrlCode(youtubeUrl) {
    let youtubeCode = undefined;
    let matches = youtubeUrl.match(
      /youtube\.com\/(?:embed\?v=|watch\?v=)([a-zA-Z0-9_-]+)/,
    );
    if (!matches) return youtubeCode;
    if (matches.length > 1) {
      youtubeCode = matches[1];
    }
    return youtubeCode;
  }
}

customElements.define("r-modal-button", ModalButton);

/*
  LS - Video layer
*/
class VideoLayer extends HTMLElement {
  constructor() {
    super();

    let root = this;
    this.isDebug = false;
    this.videoSourceElement = null;
    this.videoElement = null;
    this.isDesktop = null;

    this.videoSrc = this.getAttribute("src");
    this.desktopVideoSrc = this.getAttribute("desktop-src");
    this.desktopBreakpoint = this.getAttribute("desktop-breakpoint");

    this.debug({
      videoSrc: this.videoSrc,
      desktopVideoSrc: this.desktopVideoSrc,
      desktopBreakpoint: this.desktopBreakpoint,
    });

    if (this.videoSrc != null) {
      let type = "video";
      if (this.desktopVideoSrc != null && this.desktopBreakpoint != null) {
        type = "mobile-video/desktop-video";
      }

      if (type == "video") {
        root.viewUpdate();
      }

      if (type == "mobile-video/desktop-video") {
        document.addEventListener("DOMContentLoaded", function () {
          window.addEventListener(
            "resize",
            function () {
              root.resizeHandler();
            }.bind(root),
          );
          root.resizeHandler();
        });
      }
    }
  }

  resizeHandler() {
    let root = this;
    let isDesktop = window.outerWidth >= root.desktopBreakpoint;
    if (isDesktop) {
      if (root.isDesktop != true) {
        root.isDesktop = true;
        root.viewUpdate();
      }
    } else {
      if (root.isDesktop != false) {
        root.isDesktop = false;
        root.viewUpdate();
      }
    }
  }

  viewUpdate() {
    let root = this;
    let videoSrc = root.videoSrc;
    if (root.isDesktop) {
      videoSrc = root.desktopVideoSrc;
    }

    if (root.videoSourceElement == null) {
      let videoLayer = this;
      //videoLayer.classList.add('video-layer');
      videoLayer.style.position = "absolute";
      videoLayer.style.top = "0px";
      videoLayer.style.left = "0px";
      videoLayer.style.bottom = "0px";
      videoLayer.style.right = "0px";
      videoLayer.style.overflow = "hidden";
      //videoLayer.style.backgroundColor = '#484a40';
      //videoLayer.style.border = 'red solid 2px';

      let video = document.createElement("video");
      video.setAttribute("width", "100%");
      video.setAttribute("height", "100%");
      video.autoplay = true;
      video.defaultMuted = true; // video.defaultMuted is the property that reflects to the muted attribute
      video.muted = true; // to play in Chrome on page load recently
      video.playsInline = true;
      video.loop = true;
      video.style.objectFit = "cover";

      let videoSource = document.createElement("source");
      videoSource.setAttribute("type", "video/mp4");
      videoSource.setAttribute("src", videoSrc);
      video.append(videoSource);
      videoLayer.append(video);

      root.videoElement = video;
      root.videoSourceElement = videoSource;
    }

    if (root.videoSourceElement != null) {
      root.videoSourceElement.setAttribute("src", videoSrc);
      root.videoElement.load();
    }
  }

  debug(args) {
    if (this.isDebug) {
      console.log(args);
    }
  }
}

customElements.define("r-video-layer", VideoLayer);

/*
  LS - (Gallery) video lazy load
*/
document.addEventListener("DOMContentLoaded", function () {
  let lazyVideos = [...document.querySelectorAll("video.r-js-video-lazy")];
  if ("IntersectionObserver" in window) {
    let lazyVideoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (let source in video.target.children) {
            let videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }
          video.target.load();
          video.target.classList.remove("r-js-video-lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });
    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

/*
  LS - RecentlyViewed
*/
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector(`#Slider-${this.dataset.sectionId}`);
    this.maxItem = this.dataset.maxItem;

    this.getRecentlyViewedProducts();
  }

  async getRecentlyViewedProducts() {
    let handleList = [];

    const productData = JSON.parse(
      localStorage.getItem("recentlyViewedProduct"),
    );
    if (productData == null) return false;

    let newData = productData.filter((product) =>
      product.hasOwnProperty("productID"),
    );
    if (newData.length == 0) return false;
    newData.map((product) => {
      handleList.unshift(`${product?.productID}`);
    });
    handleList = handleList.slice(0, this.maxItem).join("_");
    // console.log({handleList:handleList});

    let url = `${routes.search_url}?view=recently-view&q=${handleList}`;
    if (this.dataset.optionRelated == "true") {
      url = `${routes.search_url}?view=recently-related-view&q=${handleList}`;
    }

    const parser = new DOMParser();
    const response = await fetch(url);

    if (!response.ok) {
      var error = new Error(response.status);
      console.warn("Something went wrong.", error.message);
      throw error;
    }

    let responseText = await response.text();
    responseText = this.replaceAll(
      responseText,
      "[section.id]",
      this.dataset.sectionId,
    );
    const responseHTML = parser
      .parseFromString(responseText, "text/html")
      .querySelector("#container").innerHTML;
    this.container.innerHTML = responseHTML;
    let cards = this.container.querySelectorAll(".card-wrapper, .grid__item");
    if (cards.length > 0) {
      this.initSlider();
      this.container.closest(".shopify-section").classList.remove("hidden");
    }
  }

  initSlider() {
    const slide = this.querySelector("slider-component");
    if (slide) {
      slide.resetPages();
    }

    requestAnimationFrame(() => {
      this.container.dispatchEvent(new Event('scroll'));
    });
  }

  replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  }
}

customElements.define("recently-viewed", RecentlyViewed);

/*
  LS - FeaturedBundle
*/
class FeaturedBundle extends HTMLElement {
  constructor() {
    super();

    this.variants = [];
    this.price = this.querySelector(".total-price");
    this.button = this.querySelector("button");
    this.data = JSON.parse(
      this.querySelector('[type="application/json"]').innerHTML,
    );
    this.checkboxes = this.querySelectorAll('li input[type="checkbox"]');
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.init();
  }

  init() {
    this.updateVariants();
    this.calculateTotal();
    this.initEvents();
  }

  initEvents() {
    this.checkboxes.forEach((cb) => {
      cb.addEventListener("change", () => {
        this.updateVariants();
        this.calculateTotal();
      });
    });

    this.button.addEventListener("click", this.handleSubmit.bind(this));
  }

  updateVariants() {
    this.variants = [];
    const cbs = this.querySelectorAll('li input[type="checkbox"]:checked');
    cbs.forEach((cb) => this.variants.push(parseInt(cb.value)));
    if (this.variants.length == 0) {
      this.button.setAttribute("aria-disabled", true);
    } else {
      this.button.removeAttribute("aria-disabled");
    }
  }

  calculateTotal() {
    let total = 0;
    this.data.products.forEach((pr) => {
      if (this.variants.includes(pr.id)) {
        total += parseFloat(pr.price);
      }
    });
    this.price.innerHTML = `${this.data.config.currencySymbol}${parseFloat(
      total,
    ).toFixed(2)} ${this.data.config.priceCurrency}`;
  }

  handleCartUpsellHeader() {
    const upsellsContainer = document.querySelector(".cart-upsells");

    if (upsellsContainer !== null) {
      let upsellItemsLength = 0;
      const upsellsInner = upsellsContainer.querySelector(
        ".cart-upsells__inner",
      );
      if (upsellsInner !== null) {
        const upsellItems = upsellsInner.querySelectorAll(".cart-upsell__item");
        if (upsellsInner !== null) {
          upsellItemsLength = upsellItems.length;
        }
      }

      const upsellsHeader = upsellsContainer.querySelector(
        ".cart-upsells__header",
      );
      if (upsellsHeader !== null) {
        if (upsellItemsLength == 0) {
          upsellsHeader.style.display = "none";
        } else {
          upsellsHeader.style.display = "";
        }
      }
    }
  }

  handleSubmit() {
    if (this.button.getAttribute("aria-disabled") === "true") return;

    this.button.setAttribute("aria-disabled", true);
    this.button.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    let items = this.variants.map((id) => {
      return {
        id: id,
        quantity: 1,
      };
    });

    let body = { items };
    if (this.cart) {
      body["sections"] = this.cart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(",");
      body["sections_url"] = window.location.pathname;
    }
    let config = {
      ...fetchConfig("javascript"),
      body: JSON.stringify(body),
    };
    // console.log({config:config});

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.error = false;
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.handleCartUpsellHeader();
        this.button.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.button.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      });
  }
}

customElements.define("featured-bundle", FeaturedBundle);

/*
   LS - AddToCart (cart cross sell)
*/
class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.addEventListener("click", this.handleSubmit.bind(this));
  }

  handleSubmit() {
    if (this.getAttribute("aria-disabled") === "true") return;

    this.setAttribute("aria-disabled", true);
    this.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    let items = [
      {
        id: this.dataset.id,
        quantity: 1,
      },
    ];
    let body = { items };
    if (this.cart) {
      body["sections"] = this.cart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(",");
      body["sections_url"] = window.location.pathname;
    }
    let config = {
      ...fetchConfig("javascript"),
      body: JSON.stringify(body),
    };

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.setAttribute("aria-disabled", true);
          this.querySelector("span").classList.add("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      });
  }
}

customElements.define("add-to-cart", AddToCart);

/*
  Switches Combined Listings Tabs on Product Pages
*/

function showCombinedListingsTab(sectionId, type) {
  const tabId = `${type}-${sectionId}`;
  const tabs = document.querySelectorAll(`.tab-${sectionId} h2`);
  const contents = document.querySelectorAll(`.tab-content-${sectionId}`);

  tabs.forEach((tab) => {
    tab.classList.remove("active");
    tab.classList.add("inactive");
  });

  contents.forEach((content) => {
    content.style.display = "none";
  });

  document.querySelector(`#${tabId}`).style.display = "revert";

  tabs.forEach((tab) => {
    const containsText = tabId
      .toLowerCase()
      .replace(/\s+/g, "")
      .includes(tab.dataset.item.toLowerCase().replace(/\s+/g, ""));

    if (containsText) {
      tab.classList.add("active");
      tab.classList.remove("inactive");
    }
  });
}

// Replace Yotpo Pictur Widget "Buy Now" Text with Shopping Cart Icon
function updateYotpoIcons() {
  let icon = document.querySelector(".icon-cart-empty");
  if (icon == null) icon = document.querySelector(".icon-cart");

  if (icon) {
    // Add the CSS styles dynamically
    const style = document.createElement("style");
    style.textContent = `
      .yotpo-pictures-widget button.yotpo-hover-cta { max-height: 56px; }
      .yotpo-pictures-widget button.yotpo-hover-cta > svg {
        max-height: 42px;
        margin-top: -6px;
      }
    `;
    document.head.appendChild(style);

    const elements = document.querySelectorAll(
      ".yotpo-pictures-widget .yotpo-hover-cta",
    );
    elements.forEach((element) => {
      const clonedIcon = icon.cloneNode(true);

      if (clonedIcon instanceof SVGElement) {
        clonedIcon.setAttribute("viewBox", "10 10 20 20");
      }

      element.innerHTML = "";
      element.appendChild(clonedIcon);
    });

    // Stop observing after icons have been updated
    yotpoObserver.disconnect();
  }
}

// Observer to watch for the presence of .yotpo-pictures-widget
const yotpoObserver = new MutationObserver(() => {
  const yotpoWidget = document.querySelector(".yotpo-pictures-widget");

  // Check if the widget is available, and if it contains the hover elements
  if (yotpoWidget && yotpoWidget.querySelector(".yotpo-hover-cta")) {
    updateYotpoIcons();
  }
});

// Start observing the body for changes, focusing on child elements being added or removed
yotpoObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// collection articles slider

var swiper = new Swiper(".collection-articles__slider", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 1.3,
  breakpoints: {
    350: {
      slidesPerView: 1.3,
    },
    480: {
      slidesPerView: 1.7,
    },
    640: {
      slidesPerView: 2.3,
    },
    750: {
      slidesPerView: 2.7,
    },
    900: {
      slidesPerView: 3.3,
    },
    1100: {
      slidesPerView: 3.7,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// video lazyload
document.addEventListener("DOMContentLoaded", () => {
  let videos = document.querySelectorAll("video[data-src]");

  if ("IntersectionObserver" in window) {
    let observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let video = entry.target;
            let src = video.getAttribute("data-src");
            if (src) {
              let source = document.createElement("source");
              source.src = src;
              source.type = "video/mp4";
              video.appendChild(source);
              video.load();
              obs.unobserve(video);
            }
          }
        });
      },
      {
        threshold: 0.25,
      },
    );

    videos.forEach((video) => observer.observe(video));
  } else {
    // Fallback for older browsers: load immediately
    videos.forEach((video) => {
      let src = video.getAttribute("data-src");
      if (src) {
        let source = document.createElement("source");
        source.src = src;
        source.type = "video/mp4";
        video.appendChild(source);
        video.load();
      }
    });
  }
});

class ProductCompareCard extends Component {
  constructor() {
    super();
    this.handleClickOutsideDropdown =
      this.#handleClickOutsideDropdown.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.#getData();
    this.#initEvents();
    document.addEventListener("click", this.handleClickOutsideDropdown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClickOutsideDropdown);
  }

  #getData() {
    this.data = JSON.parse(this.refs["product-compare-data"].innerText);
  }

  #initEvents() {
    if (!this.refs["dropdownItems"]) return;
    this.refs["dropdownItems"].forEach((item) => {
      item.addEventListener("click", () => {
        const product = this.data.find(
          (prd) => prd.id === parseInt(item.dataset.id),
        );
        if (!product) return;
        this.#updateHtml(product);
      });
    });
  }

  #updateHtml(product) {
    this.#setHtml("compare-img", product.image_tag);
    this.#setHtml("compare-title", product.title);
    this.#setHtml("compare-subtitle", product.subtitle);
    this.#setHtml("compare-ideal-for", product.ideal_for);
    this.#setHtml("compare-price", product.price);
    this.#setHtml("compare-size", product.size_html);
    this.#setHtml("compare-material", product.material);
    this.#setHtml("compare-weather-resistant", product.weather_resistant_html);
    this.#setHtml("compare-skin-friendly", product.skin_friendly_html);
    this.#setHtml("compare-spreader-bar", product.spreader_bar_html);
    this.#setHtml("compare-care", product.care);
    this.#setHtml("compare-traits", product.traits);
    if (this.refs["compare-url"])
      this.refs["compare-url"].setAttribute("href", product.url);
    this.refs.dropdown?.removeAttribute("open");
  }

  #handleClickOutsideDropdown(event) {
    if (!this.refs.dropdown?.hasAttribute("open")) return;
    if (this.refs.dropdown.contains(event.target)) return;

    this.refs.dropdown.removeAttribute("open");
  }

  #setHtml(ref, value) {
    if (!this.refs[ref]) return;
    this.refs[ref].innerHTML = value || "";
  }
}

customElements.define("product-compare-card", ProductCompareCard);

/* class HammockCalculator extends Component {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    this.switchInput = this.querySelector('[name="calculator-unit"]');
  }
}

customElements.define("hammock-calculator", HammockCalculator); */
